import React, { useContext, useEffect, useState } from 'react'
import { BASE_URL_API } from '../../../References/URLs'
import ActiveStoreContext from '../../../store/ActiveStoreContext'
import AuthContext from '../../../store/auth-context'
import styles from './CampaignCostCalculator.module.css'
import { CgSpinner } from "react-icons/cg";
import { useParams } from 'react-router'

const CampaignCostCalculator = (props) => {
    const { isOpen, onClose, amountRequired } = props
    const authCtx = useContext(AuthContext)
    const asCtx = useContext(ActiveStoreContext);
    const activeStore = (() => { try { return (asCtx?.activeStore && asCtx.activeStore.trim() !== "") ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();
    const welcomeData = JSON.parse(authCtx?.loginData)?.welcomeData
    const { campaignIdentifier } = useParams()
    const [amount, setAmount] = useState(0)
    const [walletBalance, setWalletBalance] = useState(0)
    const [isLoadingBalance, setIsLoadingBalance] = useState(false)
    const [hasInitiated, setHasInitiated] = useState(false)
    const [minRequired, setMinRequired] = useState(0)
    const [error, setError] = useState('')
    useEffect(() => {
        let p = amountRequired - walletBalance;
        setMinRequired(p)
    }, [walletBalance])
    

    useEffect(() => {
        const numAmount = parseFloat(amount);
        if (isNaN(numAmount) || numAmount < minRequired) {
            setError(`Minimum amount should be ₹${minRequired}`);
            return;
        } else {
            setError(' ')
        }
    }, [amount])


    const handleCancel = () => {
        setAmount('');
        setError('');
        onClose();
    }

    const handleAddNow = () => {
        const numAmount = parseFloat(amount);
        if (isNaN(numAmount) || numAmount < minRequired) {
            setError(`Minimum amount should be ₹${minRequired}`);
            return;
        }

        setHasInitiated(true)

        // Create a form element
        const form = document.createElement("form");
        form.method = "POST";
        form.action = BASE_URL_API + "getPayment.php";

        // Add form fields with the required data
        const data = {
            token: authCtx.token,
            firstName: welcomeData?.displayName,
            lastName: welcomeData?.role,
            email: '',
            productinfo: 'Wallet Balance',
            phone: activeStore?.storePrimaryPhone,
            address1: activeStore?.storeAddress,
            city: "city received",
            state: "state received",
            country: "",
            zipcode: "pincode received",
            udf1: activeStore?.storeIdentifier,
            udf2: JSON.parse(authCtx?.loginData)?.partnersData?.vendorIdentifier,
            udf3: campaignIdentifier,
            amount: numAmount
        };

        Object.entries(data).forEach(([key, value]) => {
            const input = document.createElement("input");
            input.type = "hidden"; // Hidden field to prevent display
            input.name = key;
            input.value = value;
            form.appendChild(input);
        });

        // Append the form to the body and submit it
        document.body.appendChild(form);
        form.submit(); // This triggers the POST request and navigates to the URL



        setError('');
        hasInitiated(false)
        // onAddFunds?.(numAmount); // Optional callback to parent
        // handleCancel();
    }

    const getStoreWalletBalance = async () => {
        setIsLoadingBalance(true)
        const response = await fetch(BASE_URL_API + "getStoreWalletBalance",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    storeIdentifier: activeStore?.storeIdentifier
                })
            })

        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo?.status === "success") {
                setWalletBalance(respo?.currentBalance)
            } else {
                if (respo?.message === "tokenExpired") {
                    authCtx.logout()
                }
                console.log(respo)
            }
        }
        setIsLoadingBalance(false)
    }

    useEffect(() => {
        getStoreWalletBalance()
    }, [])




    if (!isOpen) {
        return null
    } else {
        return (
            <div className={styles.mainWrapper}>
                <div className={styles.mainContainer}>
                    {isLoadingBalance === true ?
                        <div className={styles.mainContent}>
                            <div className={styles.mainHeader}>
                                Getting Current Balance...
                            </div>
                            <div className={styles.mainBody}>
                                <div className={styles.loaderWrapper}>
                                    <div>
                                        <CgSpinner size={30} className={styles.spinner} />
                                    </div>
                                    <div className={styles.mainTxt}>
                                        Please wait... <strong>{activeStore?.storeName}</strong>
                                    </div>
                                </div>
                            </div>

                            <div className={styles.mainFooter}>
                                <div className={styles.footerContainer}>
                                    <div className={styles.cancelBtn}
                                        onClick={() => handleCancel()}
                                    >
                                        Cancel
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className={styles.mainContent}>
                            <div className={styles.mainHeader}>
                                Insufficient funds!
                            </div>
                            <div className={styles.mainBody}>
                                <div className={styles.mainTxt}>
                                    Dear <strong>{activeStore?.storeName}</strong>
                                </div>
                                <div>
                                    <div className={styles.mainTxt}>
                                        You have only <strong>₹{walletBalance}</strong> in your wallet, but this campaign requires <strong>₹{amountRequired}</strong>.
                                    </div>
                                    <div className={styles.mainTxt}>
                                        You must add atleast <strong>₹{minRequired}</strong> more to run this campaign.
                                    </div>
                                    <div>
                                        <div className={styles.enterAmount}>

                                            <input
                                                placeholder="Add funds..."
                                                value={amount}
                                                onChange={(e) => setAmount(e.target.value)}
                                                type="number"
                                                min={minRequired}
                                                autoFocus
                                            />
                                        </div>

                                    </div>
                                </div>
                                <div className={styles.errorText}>
                                    {error}
                                </div>
                            </div>
                            <div className={styles.mainFooter}>
                                {hasInitiated === false ?
                                    <div className={styles.footerContainer}>
                                        <div className={styles.cancelBtn}
                                            onClick={() => handleCancel()}
                                        >
                                            Cancel
                                        </div>
                                        <div className={styles.addNowBtn}
                                            onClick={() => handleAddNow()}
                                        >
                                            Add Now
                                        </div>
                                    </div>
                                    :
                                    <div className={styles.footerContainer}>
                                        <div className={styles.addNowBtn}
                                        >
                                            Adding...
                                        </div>
                                    </div>

                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

export default CampaignCostCalculator